import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ExistenceAuditRequest, ExistenceCountResponse, InventoryAuditRequest, MakeInventoryResponse } from 'src/app/models/inventory.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { UserResponse } from 'src/app/models/user.model';

@Component({
  selector: 'app-make-inventory',
  templateUrl: './make-inventory.component.html',
  styleUrls: ['./make-inventory.component.scss']
})
export class MakeInventoryComponent implements OnInit {
  product = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  allProducts: ProductResponse[] = [];
  allWarehouses: WarehouseResponse[] = [];
  warehouse = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  loading = true;
  list: ProductResponse[] = [];
  listIds: { [key: number]: ProductResponse } = {};
  timeout = null;
  user = null;
  result: MakeInventoryResponse = null;
  counted: { [key: number]: ExistenceCountResponse } = {};

  constructor(
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private inventoryService: InventoryService
  ) {
    this.user = JSON.parse(authService.getCurrentUser());
    
  }

  ngOnInit(): void {
    this.getStart();
  }

  reset() {
    this.list = [];
    this.listIds = {};
  }

  getStart() {
    this.product = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
    this.warehouse = new InputAutocompleteModel("", false, true, "", "loading", "", "", null, []);
    this.allProducts = [];
    this.productService.getProducts(this.product.value).pipe(
      concatMap((response: ResponseObject) => {
        response.data.forEach(element => {
          element.units = 0;
        });
        this.product.filterElements = response.data;
        this.product.class = response.data.length > 0 ? 'fa-list' : 'fa-xmark';
        this.allProducts = response.data;
        return this.warehouseService.getWarehouses();
      })
    ).subscribe(
      {
        next: (response: ResponseObject) => {
          this.warehouse.filterElements = response.data;
          this.warehouse.class = response.data.length > 0 ? 'fa-list' : 'fa-xmark';
          this.allWarehouses = response.data;
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  writeWarehouse() {
    clearTimeout(this.timeout);
    this.warehouse.class = "typing";
    this.warehouse.data = null;
    this.timeout = setTimeout(() => {
      var min = this.warehouse.value.toLowerCase();
      if (min) {
        this.warehouse.filterElements = this.allWarehouses.filter((warehouse) => {
          return warehouse.code?.toLowerCase().includes(min) || warehouse.name?.toLowerCase().includes(min);
        });
        if (this.warehouse.filterElements.length > 0) {
          this.warehouse.class = "fa-filter";
        } else {
          this.warehouse.class = "fa-filter-circle-xmark";
        }
      } else {
        this.warehouse.class = "fa-list";
        this.warehouse.filterElements = this.allWarehouses;
      }
    }, 500);
  }

  writeProduct() {
    clearTimeout(this.timeout);
    this.product.class = "typing";
    this.timeout = setTimeout(() => {
      var min = this.product.value.toLowerCase();
      if (min) {
        this.product.filterElements = this.allProducts.filter((product) => {
          return product.barCode?.toLowerCase().includes(min) || product.code?.toLowerCase().includes(min)
            || product.name?.toLowerCase().includes(min);
        });
        if (this.product.filterElements.length > 0) {
          this.product.class = "fa-filter";
        } else {
          this.product.class = "fa-filter-circle-xmark";
        }
      } else {
        this.product.class = "fa-list";
        this.product.filterElements = this.allProducts;
      }
    }, 500);
  }

  selectWarehouse(warehouse: WarehouseResponse) {
    this.warehouse.value = warehouse.name;
    this.warehouse.verified = true;
    this.warehouse.data = warehouse;
    this.warehouse.class = "fa-circle-check";
    this.inventoryService.getHistoryInventoryRandomByWarehouse(this.warehouse.data.id).subscribe({
      next: (response: ResponseObject) => {
        var res = response.data as ExistenceCountResponse[];
        this.counted = {};
        res.forEach((existence) => {
          this.counted[existence.product.id] = existence;
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  selectProduct(product: ProductResponse) {
    clearTimeout(this.timeout);
    this.product.value = "";
    this.product.filterElements = this.allProducts;
    this.product.class = "fa-list";
    if (this.listIds[product.id]) {
      this.toastService.info("El producto ya se encuentra agregado!");
      return;
    } else {
      var temp = Object.assign({}, product);
      this.productService.getExistence(this.warehouse.data.id, product.id).subscribe(
        {
          next: (response: ResponseObject) => {
            temp.existences = response.data;
            this.list.push(temp);
            this.listIds[product.id] = temp;
          },
          error: (error: HttpErrorResponse) => {
            temp.existences = 0;
            this.list.push(temp);
            this.listIds[product.id] = temp;
            this.toastService.error(error.error.message);
          }
        }
      );
    }
  }

  getProducts() {
    this.productService.getProducts(this.product.value).subscribe({
      next: (response: ResponseObject) => {
        this.product.filterElements = response.data;
      }
    })
  }

  calc(product: ProductResponse) {
    clearTimeout(this.timeout);
    product.units = null;
    this.timeout = setTimeout(() => {
      try {
        product.units = eval(product.calc);
      } catch (error) {
        product.units = null;
      }
    }, 500);
  }

  save() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var request = new InventoryAuditRequest();
    request.auditor = this.user.id;
    request.existences = [];
    request.warehouse = this.warehouse.data.id;
    this.list.forEach((existence) => {
      var temp = new ExistenceAuditRequest();
      temp.physicalStock = existence.units;
      temp.product = existence.id;
      request.existences.push(temp);
    });
    this.inventoryService.saveAudit(
      request
    ).subscribe({
      next: (response: ResponseObject) => {
        this.buttonSave.loading = false;
        var res = response.data;
        this.reset();
        this.result = res;
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  verifiedSave() {
    var sum = 0;
    this.list.forEach((product) => {
      if (product.calc) {
        sum++;
      }
    });
    return sum != this.list.length;
  }

  removeProduct(index: number, product: ProductResponse) {
    this.list.splice(index, 1);
    delete this.listIds[product.id];
  }
}
